import { Modules, useConfig } from 'scbk-services';
import { initAppsFlyer } from './service/AppsFlyerService';

export const useAppsFlyer = () => {
  const { afWebAppId } = useConfig().getConfig(Modules.COMMON);

  const init = () => {
    initAppsFlyer(afWebAppId);
  };

  return {
    init,
  };
};
